const STORAGE_KEY = "ceasa_auth";

export interface AuthState {
  token: string;
  userID: string;
  expiredAt: number;
  mustChangePassword: boolean;
  role: string;
}

type Listener = () => void;
const listeners = new Set<Listener>();

function readStorage(): AuthState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<AuthState>;
    return {
      token: parsed.token ?? "",
      userID: parsed.userID ?? "",
      expiredAt: parsed.expiredAt ?? 0,
      mustChangePassword: parsed.mustChangePassword ?? false,
      role: parsed.role ?? "",
    };
  } catch {
    return null;
  }
}

let cached: AuthState | null = readStorage();

export function getSnapshot(): AuthState | null {
  return cached;
}

export function getToken(): string | null {
  return cached?.token ?? null;
}

export function setAuth(state: AuthState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  cached = state;
  listeners.forEach((l) => l());
}

export function clearAuth(): void {
  localStorage.removeItem(STORAGE_KEY);
  cached = null;
  listeners.forEach((l) => l());
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
